/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClientLight,
    ClientLightFromJSON,
    ClientLightFromJSONTyped,
    ClientLightToJSON,
    UserGroup,
    UserGroupFromJSON,
    UserGroupFromJSONTyped,
    UserGroupToJSON,
    UserRole,
    UserRoleFromJSON,
    UserRoleFromJSONTyped,
    UserRoleToJSON,
    UserTokenUserNestedExternalSystem,
    UserTokenUserNestedExternalSystemFromJSON,
    UserTokenUserNestedExternalSystemFromJSONTyped,
    UserTokenUserNestedExternalSystemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyUser
 */
export interface ReadOnlyUser {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyUser
     */
    readonly id?: number;
    /**
     * 
     * @type {ClientLight}
     * @memberof ReadOnlyUser
     */
    client?: ClientLight;
    /**
     * 
     * @type {Array<UserGroup>}
     * @memberof ReadOnlyUser
     */
    readonly userGroup?: Array<UserGroup>;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof ReadOnlyUser
     */
    readonly userRoles?: Array<UserRole>;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyUser
     */
    lastLogin?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUser
     */
    ssoId?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyUser
     */
    loginCredentials?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUser
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUser
     */
    surname: string;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyUser
     */
    contact?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUser
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyUser
     */
    deleted: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyUser
     */
    active: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyUser
     */
    averageSpeed: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUser
     */
    languageIso6391?: string | null;
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof ReadOnlyUser
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyUser
     */
    isContactPerson?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUser
     */
    binaryRights?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUser
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyUser
     */
    binaryRightsBackup?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyUser
     */
    isSsoAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyUser
     */
    binaryRightsDirty?: boolean;
    /**
     * 
     * @type {UserTokenUserNestedExternalSystem}
     * @memberof ReadOnlyUser
     */
    externalSystem?: UserTokenUserNestedExternalSystem;
}

export function ReadOnlyUserFromJSON(json: any): ReadOnlyUser {
    return ReadOnlyUserFromJSONTyped(json, false);
}

export function ReadOnlyUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'client': !exists(json, 'client') ? undefined : ClientLightFromJSON(json['client']),
        'userGroup': !exists(json, 'user_group') ? undefined : ((json['user_group'] as Array<any>).map(UserGroupFromJSON)),
        'userRoles': !exists(json, 'user_roles') ? undefined : ((json['user_roles'] as Array<any>).map(UserRoleFromJSON)),
        'lastLogin': !exists(json, 'last_login') ? undefined : (json['last_login'] === null ? null : new Date(json['last_login'])),
        'ssoId': !exists(json, 'sso_id') ? undefined : json['sso_id'],
        'loginCredentials': !exists(json, 'login_credentials') ? undefined : json['login_credentials'],
        'name': json['name'],
        'surname': json['surname'],
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'deleted': json['deleted'],
        'active': json['active'],
        'averageSpeed': json['average_speed'],
        'languageIso6391': !exists(json, 'language_iso_639_1') ? undefined : json['language_iso_639_1'],
        'isActive': !exists(json, 'is_active') ? undefined : json['is_active'],
        'isContactPerson': !exists(json, 'is_contact_person') ? undefined : json['is_contact_person'],
        'binaryRights': !exists(json, 'binary_rights') ? undefined : json['binary_rights'],
        'externalId': !exists(json, 'external_id') ? undefined : json['external_id'],
        'binaryRightsBackup': !exists(json, 'binary_rights_backup') ? undefined : json['binary_rights_backup'],
        'isSsoAdmin': !exists(json, 'is_sso_admin') ? undefined : json['is_sso_admin'],
        'binaryRightsDirty': !exists(json, 'binary_rights_dirty') ? undefined : json['binary_rights_dirty'],
        'externalSystem': !exists(json, 'external_system') ? undefined : UserTokenUserNestedExternalSystemFromJSON(json['external_system']),
    };
}

export function ReadOnlyUserToJSON(value?: ReadOnlyUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client': ClientLightToJSON(value.client),
        'last_login': value.lastLogin === undefined ? undefined : (value.lastLogin === null ? null : value.lastLogin.toISOString()),
        'sso_id': value.ssoId,
        'login_credentials': value.loginCredentials,
        'name': value.name,
        'surname': value.surname,
        'contact': value.contact,
        'note': value.note,
        'deleted': value.deleted,
        'active': value.active,
        'average_speed': value.averageSpeed,
        'language_iso_639_1': value.languageIso6391,
        'is_active': value.isActive,
        'is_contact_person': value.isContactPerson,
        'binary_rights': value.binaryRights,
        'external_id': value.externalId,
        'binary_rights_backup': value.binaryRightsBackup,
        'is_sso_admin': value.isSsoAdmin,
        'binary_rights_dirty': value.binaryRightsDirty,
        'external_system': UserTokenUserNestedExternalSystemToJSON(value.externalSystem),
    };
}


